<template>
  <main>
    <header class="page-header page-header-light bg-white border-bottom shadow-none mb-2">
      <div class="container-xl px-2">
        <div class="page-header-content pt-4 pb-3">
          <div class="row align-items-center justify-content-between">
            <div class="col-auto d-flex align-items-center mb-3 mb-sm-0">
              <div>
                <h6 class="text-gray-600 font-weight-bold mb-1">
                  <i class="fas fa-file-medical-alt fa-fw"></i>
                  Perfil de Usuario
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <div class="container-xl px-2 mt-2">
      <div class="row" v-if="historia.finalizada === 'N'">
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-between p-4 bg-warning text-white rounded-lg shadow-xs mb-3 mt-2">
            <div class="d-flex align-items-center">
              <i class="fas fa-exclamation-triangle fa-2x mr-3 text-white-50"></i>
              <div>
                <p class="font-weight-bold mb-0">Alerta de Atención</p>
                <p class="small text-white mb-0">Este usuario tiene una historia de <span class="badge badge-light font-weight-bolder text-bold">{{ historia.tipo_historia.nombre }}</span> sin finalizar. Favor finalizar para crear una nueva.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="historia.finalizada === 'N'">
        <div class="" v-if="historia.tipo_historia && historia.tipo_historia.codigo === 'URG' && historia.ingreso==='finalizado'">
          <div class="">
            <div class="row" v-if="_can('opciones.urgencia')">
              <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-3">
                <a title="Ordenes Médicas" class="card h-200 lift shadow-sm rounded-lg border-left-lg border-left-warning" @click="ordenamiento();">
                  <div class="card-body p-3 d-flex align-items-center">
                      <div class="icon-circle bg-warning-soft text-warning mr-2"><i class="fas fa-list-alt"></i></div>
                      <div class="text-truncate">
                          <p class="text-dark mb-0 small text-truncate" >Ordenes Médicas</p>
                      </div>
                  </div>
                </a>
              </div>

              <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-3">
                <a class="card h-100 lift shadow-sm rounded-lg border-left-lg border-left-primary" @click="ordenesProcedimiento()">
                  <div class="card-body p-3 d-flex align-items-center">
                      <div class="icon-circle bg-primary-soft text-primary mr-2"><i class="fas fa-clipboard-list"></i></div>
                      <div class="text-truncate">
                          <p class="text-dark mb-0 small text-truncate" title="Procedimientos">Procedimientos</p>
                      </div>
                  </div>
                </a>
              </div>

              <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-3">
                <a class="card h-100 lift shadow-sm rounded-lg border-left-lg border-left-info cursor" @click="ordenesMedicamento();">
                  <div class="card-body p-3 d-flex align-items-center">
                      <div class="icon-circle bg-info-soft text-info mr-2"><i class="fas fa-prescription-bottle-alt"></i></div>
                      <div class="text-truncate">
                          <p class="text-dark mb-0 small text-truncate" title="Medicamentos">Medicamentos</p>
                      </div>
                  </div>
                </a>
              </div>

              <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-3">
                <a class="card h-100 lift shadow-sm rounded-lg border-left-lg border-left-success" @click="formulas();">
                  <div class="card-body p-3 d-flex align-items-center">
                      <div class="icon-circle bg-success-soft text-success mr-2"><i class="fas fa-capsules"></i></div>
                      <div class="text-truncate">
                          <p class="text-dark mb-0 small text-truncate" title="Fórmula Médica">Fórmula Médica</p>
                      </div>
                  </div>
                </a>
              </div>

              <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-3">
                <a class="card h-100 lift shadow-sm rounded-lg border-left-lg border-left-danger text-center" @click="evoluciones();">
                  <div class="card-body p-3 d-flex align-items-center">
                      <div class="icon-circle bg-danger-soft text-danger mr-2"><i class="fas fa-clipboard-check"></i></div>
                      <div class="text-truncate">
                          <p class="text-dark mb-0 small text-truncate" title="Evoluciones">Evoluciones</p>
                      </div>
                  </div>
                </a>
              </div>

              <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-3">
                <a class="card h-100 lift shadow-sm rounded-lg border-left-lg border-left-secondary" data-target="#modalRemisionesPerfil" data-toggle="modal">
                  <div class="card-body p-3 d-flex align-items-center">
                      <div class="icon-circle bg-secondary-soft text-secondary mr-2"><i class="fas fa-file-medical"></i></div>
                      <div class="text-truncate">
                          <p class="text-dark mb-0 small text-truncate" title="Remisiones">Remisiones</p>
                      </div>
                  </div>
                </a>
                <modal-remision-perfil :idHistoria="historia.id" :usuario="usuario"></modal-remision-perfil>
              </div>
            </div>
            <div class="row" v-else>
              <div class="col-xl-2 col-md-4 col-sm-6 col-12 mb-3">
                <a class="card h-100 lift shadow-sm rounded-lg border-left-lg border-left-warning" @click="ordenamiento();">
                  <div class="card-body p-3 d-flex align-items-center">
                      <div class="icon-circle bg-warning-soft text-warning mr-2"><i class="fas fa-list-alt"></i></div>
                      <div class="text-truncate">
                          <p class="text-dark mb-0 small text-truncate" title="Ordenes Médicas">Ordenes Médicas</p>
                      </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="col-xl-4 mt-2">

          <!-- informacion usuario card-->
          <div class="card mt-4"  v-show="!Object.keys(usuario).length">
            <div class="card-body">
              <content-placeholders :rounded="true">
                <content-placeholders-heading :img="true" />
                <content-placeholders-text :lines="3" />
              </content-placeholders>
            </div>
          </div>
          <div class="card border-0 shadow-sm rounded-lg mb-4" v-show="Object.keys(usuario).length">
            <modalInformacionUsuario :usuario="usuario"></modalInformacionUsuario>
            <div class="card-body p-3">
                <div class="row align-items-center mb-2">
                  <div class="col-lg-12 d-flex flex-column align-items-center text-center">
                    <div class="bg-light avatar avatar-xl shadow-sm mb-3" :class="{'avatar-online':usuario.activo === 'S','avatar-busy':usuario.activo === 'N'}">
                      <img v-if="usuario.sexo === 'F'" class="avatar-img img-fluid" src="@/assets/img-genero/mujer.png" >
                      <img v-if="usuario.sexo === 'M'" class="avatar-img img-fluid" src="@/assets/img-genero/hombre.png" >
                    </div>
                    <h6 class="font-weight-bolder text-dark mb-1 text-uppercase">
                      {{ usuario.nombre_1 }} {{ usuario.nombre_2 }} {{ usuario.apellido_1 }} {{ usuario.apellido_2 }}
                    </h6>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-lg-12">
                     <div class="mb-3 d-flex flex-column align-items-start">
                        <div class="text-bold font-weight-bold mb-2">
                          F. Nac. {{ usuario.fecha_nacimiento | formatDate }} <span class="text-muted font-weight-normal mx-1">|</span> <span class="text-bold font-weight-bold" v-if="usuario.tipo_documento">({{usuario.tipo_documento.codigo }}) {{usuario.documento}}</span>
                        </div>
                        <span class="badge badge-light font-italic text-bold italic px-3 py-2 rounded-lg font-weight-bold mb-3">
                          {{usuario.years}}
                        </span>
                        <div class="w-100 bg-light rounded-lg p-2 d-flex align-items-center">
                          <i class="fas fa-hospital-alt text-primary mr-2 fa-sm"></i>
                          <span class="text-primary font-italic text-uppercase">{{eps}}</span>
                        </div>
                     </div>

                    <div class="d-flex flex-column flex-sm-row justify-content-between mt-4">
                      <button class="btn btn-light btn-sm font-weight-bold shadow-sm mb-2 mb-sm-0 mr-sm-2 flex-grow-1" data-toggle="modal" data-target="#perfilUsuario">
                        Ver más <i class="fas fa-eye ml-1"></i>
                      </button>
                      <router-link :to="{ name: 'usuario.historial.historias', params: { id: usuario.id } }" class="btn btn-secondary btn-sm font-weight-bold shadow-sm flex-grow-1">
                        Historial H.C <i class="fas fa-file-medical ml-1"></i>
                      </router-link>
                    </div>
                  </div>
                </div>
            </div>
          </div>

            <div class="card mt-3" v-if="false">
              <cardPartograma :idUsuario="usuario.id" :usuario="usuario"></cardPartograma>
            </div>
          <!-- apgar familiar card-->
          <div >
            <div class="card border-0 shadow-sm rounded-lg mt-3"  v-show="!Object.keys(usuario).length">
              <div class="card-body p-4">
                <content-placeholders :rounded="true">
                  <content-placeholders-heading :img="false" />
                  <content-placeholders-text :lines="3" />
                </content-placeholders>
              </div>
            </div>
            <div class="card shadow-sm rounded-lg mb-4 mt-3" v-show="Object.keys(usuario).length">
              <!-- apgar familiar card-->
              <cardApgarFamiliar :idUsuario="usuario.id" :usuario="usuario"></cardApgarFamiliar>
            </div>
          </div>

          <div >
            <div class="card border-0 shadow-sm rounded-lg mt-3"  v-show="!Object.keys(usuario).length">
              <div class="card-body p-4">
                <content-placeholders :rounded="true">
                  <content-placeholders-heading :img="false" />
                  <content-placeholders-text :lines="3" />
                </content-placeholders>
              </div>
            </div>
            <div class="card border-0 shadow-sm rounded-lg mb-4 mt-3" v-show="Object.keys(usuario).length">
              <!-- certificate medical card-->
              <cardMedicalCertificate :idUsuario="usuario.id" :usuario="usuario"></cardMedicalCertificate>
            </div>
          </div>

          <!-- embarazo card-->
          <div v-if="usuario.sexo === 'F'">
            <div class="card border-0 shadow-sm rounded-lg mt-3"  v-show="!Object.keys(usuario).length">
              <div class="card-body p-4">
                <content-placeholders :rounded="true">
                  <content-placeholders-heading :img="false" />
                  <content-placeholders-text :lines="3" />
                </content-placeholders>
              </div>
            </div>
            <div class="card border-0 shadow-sm rounded-lg mb-4 mt-3" v-show="Object.keys(usuario).length">
              <!-- embarazo card-->
              <cardEmbarazo :idUsuario="usuario.id" :usuario="usuario"></cardEmbarazo>
            </div>
          </div>

        </div>
        <!-- Antecedentes card-->
        <div class="col-xl-5 mt-2">
          <alertAntecedente :usuario="usuario"></alertAntecedente>
          <VictimArmedConflict v-show="Number(usuario.victima_conflicto) === 1"></VictimArmedConflict>
          <div>
            <div class="card border-0 shadow-sm rounded-lg mt-3"  v-show="!Object.keys(usuario).length">
              <div class="card-body p-4">
                <content-placeholders :rounded="true">
                  <content-placeholders-heading :img="false" />
                  <content-placeholders-text :lines="3" />
                </content-placeholders>
              </div>
            </div>
            <div v-show="Object.keys(usuario).length">
              <cardAntecedente :idUsuario="usuario.id"></cardAntecedente>
            </div>
          </div>

          <!-- citologias card-->
          <div v-if="usuario.sexo === 'F'" >
            <div class="card border-0 shadow-sm rounded-lg mt-3"  v-show="!Object.keys(usuario).length">
              <div class="card-body p-4">
                <content-placeholders :rounded="true">
                  <content-placeholders-heading :img="false" />
                  <content-placeholders-text :lines="3" />
                </content-placeholders>
              </div>
            </div>
            <div class="card border-0 shadow-sm rounded-lg mb-4" v-show="Object.keys(usuario).length">
              <!-- citologias card-->
              <card-citologias :id-usuario="usuario.id"></card-citologias>
            </div>
          </div>
        </div>

        <div class="col-xl-3 mt-2">

          <!-- botones card-->
          <div class="card border-0 shadow-sm rounded-lg mt-3"  v-show="isLoading">
            <div class="card-body p-4">
              <content-placeholders :rounded="true">
                <content-placeholders-heading :img="false" />
                <content-placeholders-text :lines="3" />
              </content-placeholders>
            </div>
          </div>
          <div class="card border-0 bg-transparent mb-4" v-show="!isLoading && _can('create.historia')" >
            <div class="card-body p-0 text-center" v-if="Object.entries(triage).length && historia.finalizada !== 'N'">
              <button class="btn btn-primary btn-block p-4 d-flex align-items-center justify-content-between shadow-sm rounded-lg lift" type="button" @click="historiaUrgencia();">
                <div class="text-left">
                  <div class="small font-weight-bold text-white-50 text-uppercase tracking-widest mb-1">Atención Médica</div>
                  <div class="h5 mb-0 text-white font-weight-bold">Llenar Historia Urgencia</div>
                </div>
                <i class="fas fa-arrow-right fa-2x"></i>
              </button>
            </div>
            <div class="card-body  p-0 text-center" v-else-if="historia.finalizada !== 'N'">
              <div v-if="citaId===null" class="bg-warning text-white p-4 border-0 shadow-sm rounded-lg">
                  Para llenar una historia el usuario debe tener una cita confirmada
              </div>
              <div v-else>
                <button class="btn btn-primary btn-block p-4 d-flex align-items-center justify-content-between shadow-sm rounded-lg lift" type="button"  @click="abrirModalPerfil()" >
                  <div class="text-left">
                    <div class="small font-weight-bold text-white-50 text-uppercase tracking-widest mb-1">Atención Médica</div>
                    <div class="h5 mb-0 text-white font-weight-bold">Llenar Historia</div>
                  </div>
                  <i class="fas fa-arrow-right fa-2x"></i>
                </button>
              </div>
              
            </div>
            <div class="card-body p-0" v-else-if="historia.finalizada === 'N'">
              <div class="row" v-if="historia.tipo_historia.codigo === 'URG'">
                <div class="col-12 mt-2" v-if="historia.ingreso==='finalizado'">
                  <finalizar-historia :idHistoria="historia.id" :idUsuario="usuario.id" :codigoHistoria="historia.tipo_historia.codigo"></finalizar-historia>
                </div>
                <div class="col-12 mt-2">
                  <button @click="continuarHistoria();" v-if="historia.ingreso !== 'finalizado'"
                    class="btn btn-secondary btn-block p-4 d-flex align-items-center justify-content-between shadow-sm rounded-lg lift" type="button">
                    <div class="text-left">
                      <div class="small font-weight-bold text-white-50 text-uppercase tracking-widest mb-1">Atención Médica</div>
                      <div class="h5 mb-0 text-white font-weight-bold">Continuar Historia</div>
                    </div>
                    <i class="fas fa-arrow-right fa-2x"></i>
                  </button>
                </div>
                <div class="col-12 mt-1 mb-2" v-if="historia.ingreso==='finalizado'">
                  <incapacidad-component :idHistoria="historia.id" :usuario="usuario"></incapacidad-component>
                </div>
              </div>
              <div v-else class="text-center">
                <button @click="continuarHistoria();" class="btn btn-secondary btn-block p-4 d-flex align-items-center justify-content-between shadow-sm rounded-lg lift" type="button">
                    <div class="text-left">
                      <div class="small font-weight-bold text-white-50 text-uppercase tracking-widest mb-1">Atención Médica</div>
                      <div class="h5 mb-0 text-white font-weight-bold">Continuar Historia</div>
                    </div>
                    <i class="fas fa-arrow-right fa-2x"></i>
                </button>
              </div>
            </div>
          </div>

          <modalPerfil ref="modalPerfil" :usuario="usuario" :id-cita="citaId" :idTipoHistoria="idTipoHistoria"></modalPerfil>

          <!-- <div v-if="historia.tipo_historia">
            <div class="card" v-if="historia.tipo_historia.codigo === 'URG'">
              <div class="card-body text-center">
                <button @click="ordenamiento();" class="btn btn-warning  btn-md" type="button">
                  Ver Ordenes Médicas <i class="far fa-list-alt fa-fw"></i>
                </button>
              </div>
            </div>

            <div class="card mt-4" v-if="historia.tipo_historia.codigo === 'URG'">
              <div class="card-body text-center">
                <button @click="ordenesMedicamento();" class="btn btn-info  btn-md" type="button">
                  Orden de Medicamentos <i class="fas fa-capsules fa-fw"></i>
                </button>
              </div>
            </div>

            <div class="card mt-4" v-if="historia.tipo_historia.codigo === 'URG'">
              <div class="card-body text-center">
                <button @click="ordenesProcedimiento();" class="btn btn-info  btn-md" type="button">
                  Orden de Procedimientos <i class="fas fa-clipboard-list fa-fw"></i>
                </button>
              </div>
            </div>

            <div class="card mt-4" v-if="historia.tipo_historia.codigo === 'URG'">
              <div class="card-body text-center">
                <button @click="formulas();" class="btn btn-primary  btn-md" type="button">
                  Fórmula Médica  <i class="fas fa-capsules fa-fw"></i>
                </button>
              </div>
            </div>

            <div class="card mt-4" v-if="historia.tipo_historia.codigo === 'URG'">
              <div class="card-body text-center">
                <button @click="evoluciones();" class="btn btn-success  btn-lg" type="button">
                  Evoluciones <i class="fas fa-clipboard-check fa-fw"></i>
                </button>
              </div>
            </div>
          </div> -->

          <!-- notas enfremeria card-->
          <div>
            <div class="card border-0 shadow-sm rounded-lg mt-4"  v-show="!Object.keys(usuario).length">
              <div class="card-body p-4">
                <content-placeholders :rounded="true">
                  <content-placeholders-heading :img="false" />
                  <content-placeholders-text :lines="3" />
                </content-placeholders>
              </div>
            </div>
            <div class="card border-0 shadow-sm rounded-lg mt-4" v-show="Object.keys(usuario).length">
              <!-- notas enfremeria card-->
              <cardNotasEnfermeria :idUsuario="id_usuario" :usuario="usuario" ></cardNotasEnfermeria>
            </div>
          </div>

           <!-- notas trabajo social card-->
           <div>
            <div class="card border-0 shadow-sm rounded-lg mt-4"  v-show="!Object.keys(usuario).length">
              <div class="card-body p-4">
                <content-placeholders :rounded="true">
                  <content-placeholders-heading :img="false" />
                  <content-placeholders-text :lines="3" />
                </content-placeholders>
              </div>
            </div>
            <div class="card border-0 shadow-sm rounded-lg mt-4" v-show="Object.keys(usuario).length">
              <!-- notas trabajo social card-->
              <cardNotasTrabajoSocial :idUsuario="id_usuario" :usuario="usuario" ></cardNotasTrabajoSocial>
            </div>
          </div>

        </div>
      </div>
    </div>
  </main>
</template>

<script>

import usuarioService from '../../../services/usuarioService';
import historiaClinicaService from '../../../services/historiaClinicaService';
import { isEmpty } from 'lodash';
import modalPerfil from './modalPerfil';
import cardAntecedente from "./cardAntecedente";
import cardApgarFamiliar from "../base/baseApgarFamiliar/cardApgarFamiliar";
import cardEmbarazo from "../base/baseEmbarazo/cardEmbarazo";
import cardNotasEnfermeria from "../base/baseNotasEnfermeria/cardNotasEnfermeria";
import urgenciaTriageService from '../../../services/urgenciaTriageService';
import urgenciaTriageHistoriaService from '../../../services/urgenciaTriageHistoriaService';
import tipoHistoriaService from '../../../services/tipoHistoriaService';
import CardCitologias from "@/views/historias/citologia/cardCitologias";
import modalInformacionUsuario from "../base/informacionUsuario/modalInformacionUsuario";
import FinalizarHistoria from '../base/finalizarHistoria/finalizarHistoria';
//import RemisionComponent from "../base/baseRemision/index";
import modalRemisionPerfil from "../base/baseRemision/modalRemisionPerfil";
import Swal from 'sweetalert2';
import incapacidadComponent from "../base/baseIncapacidades/index";
import cardNotasTrabajoSocial from "../base/baseNotaTrabajoSocial/cardNotasTrabajoSocial";
import citasService from "@/services/citasService";
import alertAntecedente from "../base/baseAlertPatient/index";
import cardMedicalCertificate from "../base/baseMedicalCertificate/cardMedicalCertificate";
import cardPartograma from '../base/basePartograma/cardPartograma.vue';
import VictimArmedConflict from '../../../components/common/alerts/VictimArmedConflict.vue';
export default {
  components: {
    CardCitologias,
    modalPerfil, cardAntecedente, cardApgarFamiliar, cardEmbarazo, cardNotasEnfermeria, modalInformacionUsuario,
    FinalizarHistoria,modalRemisionPerfil,incapacidadComponent,cardNotasTrabajoSocial,alertAntecedente,cardMedicalCertificate,cardPartograma,
    VictimArmedConflict
  },
  data() {
    return {
      historia: {
        id: '',
        fecha: '',
        id_usuario: '',
        finalizada: ''
      },
      usuario: {},
      triage: {},
      id_usuario: '',
      isLoading: true,
      eps:{},
      citaId: null,
      idTipoHistoria: null,
    }
  },
  watch:{
    'usuario':function(){
      if(isEmpty(this.usuario.contratos)){
        this.eps='Sin datos...';
      }else{
          this.eps = this.usuario.contratos[0].contrato.eps.DESEPS
      }
    }
  },
  methods: {
    ordenesProcedimiento() {
      this.$router.push({
        name: 'ordenes.usuario', params: { id_historia: this.historia.id }
      });
    },
    ordenesMedicamento() {
      this.$router.push({
        name: 'ordenes.medicamento.urgencia.usuario', params: { id_historia: this.historia.id }
      });
    },
    formulas() {
      this.$router.push({
        name: 'formulas.usuario', params: { id_historia: this.historia.id }
      });
    },
    ordenamiento() {
      this.$router.push({
        name: 'ordenamiento', params: { id: this.historia.id }
      });
    },
    evoluciones() {
      this.$router.push({
        name: 'evoluciones.usuario', params: { id_historia: this.historia.id }
      });
    },
    async cargarUsuario() {
      const response = await usuarioService.show(this.id_usuario);
      this.usuario = response.data;

    },
    continuarHistoria() {
      this.$router.push({
        name: this.historia.tipo_historia.path, params: { id: this.historia.id }
      });
    },
    async consultarTriage() {
      //this.LoaderSpinnerShow();
      this.isLoading = true;
      const response = await urgenciaTriageService.showByIdUser(this.id_usuario);
      this.triage = response.data;
      this.isLoading = false;
      //this.LoaderSpinnerHide();
    },
    async historiaUrgencia() {
      try {
        this.LoaderSpinnerShow();
        let hoy = new Date();

        let fechaAct = hoy.getFullYear() + '-' + (hoy.getMonth() + 1) + '-' + hoy.getDate();

        this.historia.fecha = fechaAct;

        const response_tipo_historia = await tipoHistoriaService.index();

        const tipoHistoria = response_tipo_historia.data.find(x => x.codigo === 'URG');

        const historia = {
          fecha: fechaAct,
          id_tipo_historia: tipoHistoria.id,
          id_usuario: this.usuario.id,
          id_eps:this.usuario.contratos?this.usuario.contratos[0].contrato.eps.id:''
        };

        const response = await historiaClinicaService.store(historia);

        const historia_triage = {
          id_historia: response.data.id,
          id_triage: this.triage.id
        }

        await urgenciaTriageHistoriaService.store(historia_triage);

        this.$router.push({
          name: tipoHistoria.path,
          params: {
            id: response.data.id
          }
        });
        this.LoaderSpinnerHide();
      } catch (err) {
        console.error(err);
        this.LoaderSpinnerHide();
        Swal.fire("Ups!", "ha ocurrido un error al procesar la solicitud", "error");
      }
    },
    async historiaFinalizada() {
      //this.LoaderSpinnerShow();
      const response = await historiaClinicaService.showUnfinished(this.id_usuario);
      //this.LoaderSpinnerHide();
      if (!isEmpty(response.data)) {
        this.historia = response.data;

      }

    },
    abrirModalPerfil(){
      this.$refs.modalPerfil.cargarTipoHistoria();
    },
    async init() {

      this.id_usuario = this.$route.params.idUsuario;

      await this.cargarUsuario();

      await this.historiaFinalizada();

      await this.consultarTriage();


      if(this.$route.query?.citaId){
        const { data } = await citasService.show(this.$route.query.citaId);
        console.log(data);
        if(data.estado === 'confirmada' && this.historia.id_cita==null) {
          this.citaId = this.$route.query.citaId;
          this.idTipoHistoria = this.$route.query.idTipoHistoria;
          localStorage.setItem(`appointment_${this.id_usuario}`, this.citaId);
          localStorage.setItem(`historia_${this.id_usuario}`, this.idTipoHistoria);
        }
      }else{
        this.citaId = localStorage.getItem(`appointment_${this.id_usuario}`);
        this.idTipoHistoria = localStorage.getItem(`historia_${this.id_usuario}`);
      }

      if(isEmpty(this.usuario.contratos)){
        this.eps='Sin datos...';
      }else{
          this.eps = this.usuario.contratos[0].contrato.eps.DESEPS
      }

    }
  },
  async mounted() {
   
    await this.init();

    
    //this.$route.query?.idTipoHistoria && (this.idTipoHistoria = this.$route.query.idTipoHistoria);

  }
}
</script>
<style scoped>
.text-h6{
  font-size:14px;
}

a:hover {
  cursor:pointer;
}
</style>
